export const sanitizeAccountHolderName = (value: string): string =>
  value.replace(/[^A-Za-z\s]/g, '')

/** Writing the raw value first lets the input render the keystroke, and the
 *  next-tick sanitized write forces the model prop to change so the input
 *  re-syncs and the disallowed characters visibly disappear. */
export const writeSanitizedHolderName = async (
  input: string | number,
  write: (value: string) => void,
): Promise<void> => {
  const raw = String(input)
  const sanitized = sanitizeAccountHolderName(raw)
  write(raw)

  if (sanitized === raw) return

  await nextTick()
  write(sanitized)
}
